import { render, staticRenderFns } from "./ui.vue?vue&type=template&id=7fb0821c&scoped=true"
import script from "./ui.vue?vue&type=script&lang=ts"
export * from "./ui.vue?vue&type=script&lang=ts"
import style0 from "./ui.vue?vue&type=style&index=0&id=7fb0821c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb0821c",
  null
  
)

export default component.exports